// extracted by mini-css-extract-plugin
module.exports = {"button":"Timer_button__1AyoZ","full-width-avatar":"Timer_full-width-avatar__xXy05","wrapper":"Timer_wrapper__2ibBA","timer":"Timer_timer__2TRgW","writing":"Timer_writing__Sf6bp"};